import { render, staticRenderFns } from "./TShrinkableButton.vue?vue&type=template&id=cfafb4da&scoped=true&"
import script from "./TShrinkableButton.vue?vue&type=script&lang=js&"
export * from "./TShrinkableButton.vue?vue&type=script&lang=js&"
import style0 from "./TShrinkableButton.vue?vue&type=style&index=0&id=cfafb4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfafb4da",
  null
  
)

export default component.exports